import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const LifeCyclePolicy = z.object({
  policies: z.object({
    newStarterEquipmentPolicy: z.string(),
    techRefreshPolicy: z.string(),
    redeploymentPolicyMaxAge: z.string(),
    redeploymentPolicyPhysicalCondition: z.string()
  })
});

export type LifeCyclePolicy = z.infer<typeof LifeCyclePolicy>;

export default c.router({
  getPolicy: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/lifeCyclePolicies',
    responses: {
      200: LifeCyclePolicy
    }
  },
  postPolicy: {
    method: 'POST',
    path: '/msp/:mspId/customers/:customerId/lifeCyclePolicies',
    responses: {
      200: LifeCyclePolicy,
      ...failedResponses
    },
    body: LifeCyclePolicy
  },
  putPolicy: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/lifeCyclePolicies',
    responses: {
      200: LifeCyclePolicy,
      ...failedResponses
    },
    body: LifeCyclePolicy
  }
});
